import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataFormatService {

  constructor() { }

  formatAccountNumber(accountNumber: string) {
    if (accountNumber.length === 16) {
      if (accountNumber.substring(3, 4) === "0") { // Old Account Number
        accountNumber = accountNumber.replace(/(0000)([0-9]{3})([0-9]{2})([0-9]{6})([0-9]{1})/, "$2-$3-$4-$5");
      } else { // New Account Number and Virtaul Account
        accountNumber = accountNumber.replace(/(000)([0-9]{1})([0-9]{3})([0-9]{8})([0-9]{1})/, "$2-$3-$4-$5");
      }
    } else if (accountNumber.length === 13) {
      if (accountNumber.substring(0, 1) === "0") { // Old Account Number
        accountNumber = accountNumber.replace(/(0)([0-9]{3})([0-9]{2})([0-9]{6})([0-9]{1})/, "$2-$3-$4-$5");
      } else { // New Account Number and Virtaul Account
        accountNumber = accountNumber.replace(/([0-9]{1})([0-9]{3})([0-9]{8})([0-9]{1})/, "$1-$2-$3-$4");
      }
    } else if (accountNumber.length === 12) { // Old Account Number
      accountNumber = accountNumber.replace(/([0-9]{3})([0-9]{2})([0-9]{6})([0-9]{1})/, "$1-$2-$3-$4");
    }
    return accountNumber;
  }

  formatPhone(tmp: string, e: any) {
    if (e.keyCode >= 48 && e.keyCode <= 57 || e.keyCode >= 96 && e.keyCode <= 105) {
      if (tmp.length >= 9) {
        tmp = tmp.replace(/([0-9]{3})([0-9]{3})([0-9])/, '$1 $2 $3');
      } else if (tmp.length >= 6 && tmp.length < 9) {
        tmp = tmp.replace(/([0-9]{3})([0-9]{3})/, '$1 $2 ');
      } else if (tmp.length >= 3 && tmp.length < 6) {
        tmp = tmp.replace(/([0-9]{3})/, '$1 ');
      }
    } else if (e.key === "Backspace") {
      if (tmp.length > 7) {
        tmp = tmp.replace(/([0-9]{3})([0-9]{3})([0-9])/, '$1 $2 $3');
      } else if (tmp.length <= 7 && tmp.length > 4) {
        tmp = tmp.replace(/([0-9]{3})([0-9])/, '$1 $2');
      } else {
        tmp = tmp.replace(/([0-9])/, '$1');
      }
    } else {
      e.preventDefault();
      if (tmp.length >= 9) {
        tmp = tmp.replace(/([0-9]{3})([0-9]{3})([0-9])/, '$1 $2 $3');
      } else if (tmp.length >= 6 && tmp.length < 9) {
        tmp = tmp.replace(/([0-9]{3})([0-9]{3})/, '$1 $2 ');
      } else if (tmp.length >= 3 && tmp.length < 6) {
        tmp = tmp.replace(/([0-9]{3})/, '$1 ');
      }
    }
    return tmp;
  }

  checkPhoneNumberdigits( phoneNumbers: string, event: any ) {
    let formattedNumber = this.formatPhone( phoneNumbers, event );
    const firstDigit = formattedNumber.substring( 0, 1 );
    const secondDigit = formattedNumber.substring( 0, 2 );
    if ( firstDigit !== '0' ) {
      return formattedNumber = '';
    } else if ( secondDigit === '00' ) {
        return formattedNumber = '0';
    } else {
        return formattedNumber;
    }
  }

  formatPhoneNumber(phoneNumber: string): string {
    if (phoneNumber.length === 9) {
      phoneNumber = phoneNumber.replace(/([0-9]{3})([0-9]{3})([0-9]{3})/, '$1-$2-$3');
    } else if (phoneNumber.length === 10) {
      phoneNumber = phoneNumber.replace(/([0-9]{3})([0-9]{3})([0-9]{4})/, '$1-$2-$3');
    }
    return phoneNumber;
  }

  unformatAccountNumber(accountNumber: string): string {
    // accountNumber = accountNumber.replace(/\D+/g, "").padStart(16, "0");
    accountNumber = accountNumber.replace(/\D+/g, "");
    return accountNumber;
  }

  formatMoney(numbers: number, currency: string): string {
    let s = '';
    const d = 2;
    if (currency === 'USD') {
      s = s + String(Number(numbers).toFixed(d).replace(/\B(?=(\d{3})+(?!\d))/g, ",")) + " " + currency;
    } else {
      s = s + (String(Math.round(numbers)).replace(/\B(?=(\d{3})+(?!\d))/g, ",")) + " " + currency;
    }

    return s;
  }

  formatMoneyNoSymbol(numbers: number, currency: string) {
    let s = '';
    const d = 2;
    if (currency === 'USD') {
      s = s + String(Number(numbers).toFixed(d).replace(/\B(?=(\d{3})+(?!\d))/g, ","));
    } else {
      s = s + (String(Math.round(numbers)).replace(/\B(?=(\d{3})+(?!\d))/g, ","));
    }
    return s;
  }

}
